/** Textos de auth en UTF-8 (evita problemas de encoding en JSX) */
export const forgotPasswordCopy = {
  title: "Recuperar contraseña",
  subtitle: "Ingresá tu email y te enviamos un enlace para restablecer tu contraseña",
  emailLabel: "Email de tu cuenta",
  submit: "Enviar enlace de recuperación",
  sending: "Enviando...",
  backToLogin: "Volver al inicio de sesión",
  successTitle: "¡Email enviado!",
  successBodyBefore: "Revisá tu bandeja de entrada en ",
  successBodyAfter: " y seguí el enlace para restablecer tu contraseña.",
};
